'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getPartialDateTimeTimeZone7 = (date) => {
  const year = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    year: "numeric"
  }).format(date);
  const month = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    month: "2-digit"
  }).format(date);
  const day = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    day: "2-digit"
  }).format(date);
  const hour = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    hour: "2-digit",
    hour12: false
  }).format(date);
  const minute = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    minute: "2-digit"
  }).format(date);
  const second = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta",
    second: "2-digit"
  }).format(date);
  return {
    year,
    month,
    day,
    hour,
    minute,
    second
  };
};

exports.getPartialDateTimeTimeZone7 = getPartialDateTimeTimeZone7;
